export default __webpack_public_path__ + "static/media/ajax-loader.e9247cb3.gif";